/**
 * 思维状态标签解析（对应 CCMA engine.go feedbackInstruction）。
 *
 * 设计哲学：不是评分，是命名。导师识别学生当下的思维状态（五选一或不输出），
 * 前端解析为视觉徽章，给学生一个"被看见"的瞬间反馈，而不是"被评价"的焦虑。
 *
 * 标签形式（导师在 </voice> 之后、正文之前输出，没识别到就不输出）：
 *   <state name="接住了">用户分层视角</state>
 *
 * 状态语义（中性，不是好坏分级）：
 *   接住了 / 烧穿了 / 冒头了 / 卡住了 / 漂走了
 */

const STATE_TAG_RE = /<state\s+name=["']([^"']+)["']\s*>([\s\S]*?)<\/state>/i;

// 状态名 → 视觉表达（emoji + 调性色）。新增状态时只需在此扩展。
export const STATE_META = {
  接住了: { emoji: "✋", tone: "warm",    aria: "接住了" },
  烧穿了: { emoji: "🔥", tone: "hot",     aria: "烧穿了" },
  冒头了: { emoji: "🌱", tone: "fresh",   aria: "冒头了" },
  卡住了: { emoji: "🧩", tone: "neutral", aria: "卡住了" },
  漂走了: { emoji: "🌊", tone: "drift",   aria: "漂走了" },
};

/**
 * 从消息正文中解析 <state> 标签。
 * @param {string} text - 原始消息内容（可能含 <voice>、<state>、A2UI 等）
 * @returns {{ state: {name: string, label: string, meta: object} | null, cleanText: string }}
 *   state: 命中时返回结构化对象；未命中或 name 非法时为 null
 *   cleanText: 已剥离 <state> 标签的文本（<voice> 等其它标签保持原样）
 */
export function parseStateTag(text) {
  if (typeof text !== "string" || !text) {
    return { state: null, cleanText: text || "" };
  }
  const m = text.match(STATE_TAG_RE);
  if (!m) {
    return { state: null, cleanText: text };
  }
  const name = (m[1] || "").trim();
  const label = (m[2] || "").trim();
  const meta = STATE_META[name];
  if (!meta) {
    // 兜底：白名单外的 name（LLM 偶发越界），仅剥离不渲染
    return { state: null, cleanText: text.replace(STATE_TAG_RE, "") };
  }
  return {
    state: { name, label, meta },
    cleanText: text.replace(STATE_TAG_RE, ""),
  };
}

/** 仅剥离 <state> 标签，用于数字人朗读等不需要渲染徽章的场景。 */
export function stripStateTag(text) {
  if (typeof text !== "string" || !text) return text || "";
  return text.replace(new RegExp(STATE_TAG_RE.source, "gi"), "");
}
